<template>
    <form-container :headerText="currentData?.settings?.name"
                    header-sub-text="Resultat eingeben"
                    :width="480" action="editRundeTabResult"
                    :valid-actions="['editRundeTabResult']"
                    @save="save()">
        <div v-if="rules && team" class="px-5 pb-3">
            <v-row no-gutters>
                <v-col class="pr-3">
                    <v-text-field v-model="team.results.volle" label="Volle" clearable type="number"
                                  :rules="team.results.status==='finished'?[rules.greaterEqualZero]:[]"/>
                </v-col>
                <v-col class="px-3">
                    <v-text-field v-model="team.results.abraeumen" label="Abräumen" clearable type="number"
                                  :rules="team.results.status==='finished'?[rules.greaterEqualZero]:[]"/>
                </v-col>
                <v-col class="pl-3">
                    <v-text-field v-model="team.results.fehlwuerfe" label="Fehlwürfe" clearable type="number"/>
                </v-col>
            </v-row>
            <v-text-field v-model="team.results.gesamt" label="Gesamt" clearable type="number"/>
            <v-text-field v-model="team.results.kommentar" label="Kommentar" clearable/>
            <v-radio-group v-model="team.results.status" :rules="[rules.required]" row>
                <v-radio v-for="(status) in resultStatus" :key="resultStatus.value" class="mb-3"
                         :label="status.label" :value="status.value"/>
            </v-radio-group>
            <div v-if="team.results.losEntscheid || team.results.positionLos">
                <v-alert color="primary" icon="mdi-information" text style="font-size: 14px">
                    Bitte gib die Position nach Losentscheid erst dann ein, wenn alle {{ label.plural }} dieses Runde
                    abgeschlossen haben!
                </v-alert>
                <v-text-field v-model="team.results.positionLos" type="number" label="Position nach Losentscheid" clearable/>
            </div>
            <v-alert v-if="error" color="primary" icon="mdi-information" text style="font-size: 14px">
                {{error }}
            </v-alert>
        </div>
    </form-container>
</template>

<script>
import FormContainer from "@/components/form/formContainer.vue";
import {FormRules} from "@/services/formRules";
import {BewerbTeamSingle} from "@/services/data/meisterschaften/bewerbTeamSingle";
import {BewerbTeamDouble} from "@/services/data/meisterschaften/bewerbTeamDouble";
import {RESULT_STATUS} from "@/services/data/meisterschaften/bewerb_constants";

export default {
    name: "meisterschaftRundeTabResultEdit",
    components: {FormContainer},
    props: ['currentData', 'currentRunde', 'bewerb'],
    data: () => ({
        rules: null,
        team: null,
        error: '',
        resultStatus: RESULT_STATUS
    }),
    computed: {
        editTeamParam(){ return this.$route.query.action === 'editRundeTabResult' },
        isDouble(){ return this.currentRunde?.settings.bewerbTyp === 'x' },
        label(){ return this.bewerb?.getTeamLabel() },
        volleOderAbraeumen(){ return this.team?.results.volle + this.team?.results.abraeumen },
    },
    created(){
        this.rules = new FormRules();
    },
    methods: {
        init(){
            this.team = !this.isDouble ? new BewerbTeamSingle(this.currentData, this.currentData?.id) :
                                         new BewerbTeamDouble(this.currentData, this.currentData?.id)
            if ( this.team.results?.status === '' ) this.team.results.status = 'finished'
        },
        clear(){
            this.team = null
            this.error = '';
        },
        async save(){
        // save
            const volleAr = parseInt(this.team.results.volle) + parseInt(this.team.results.abraeumen);
            if( volleAr > 0 && volleAr !== this.team.results.gesamt ){
                this.error = 'Die Summe von Volle und Abräumen muss 0 oder gleich Gesamt sein!'
                return
            }
            this.$store.state.local.loader = true;
            const reply = await this.team.updateTeamResultsInRunde(this.bewerb.id, this.currentRunde.id)
            reply.successful ? this.handleSuccess(reply) : this.error = reply.content
            this.$store.state.local.loader = false;
        },
        handleSuccess(reply){
            console.log ("reply", reply);
            this.bewerb.runden[this.currentRunde.id].teams = reply.content.teams
            this.team = null
            window.history.back();
        },
    },
    watch: {
        editTeamParam(to){ if ( to ) {this.init()} else {this.clear()} },
        volleOderAbraeumen(to, from){
            this.error = '';
            if ( isNaN(from) ) return
            this.team?.setResultGesamt()
        }
    }
}
</script>

<style scoped>

</style>